import App from './App.svelte';
import * as FullStory from '@fullstory/browser';
FullStory.init({ orgId: '11MTX1' });
var app = new App({
    target: document.body
});
export default app;
